import { render, staticRenderFns } from "./OnboardingScheduleDailyStandupForm.vue?vue&type=template&id=6b0a19cb&scoped=true&"
import script from "./OnboardingScheduleDailyStandupForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingScheduleDailyStandupForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingScheduleDailyStandupForm.vue?vue&type=style&index=0&id=6b0a19cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a19cb",
  null
  
)

export default component.exports